var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vuetify-alert',{staticClass:"alert",attrs:{"value":_vm.value,"type":_vm.type,"dismissible":_vm.dismissible}},[(_vm.message)?[_vm._v(" "+_vm._s(_vm.message)+" ")]:[_vm._t("default")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }